import { createContext, FC, useEffect, useMemo } from 'react';
import { MediaType, useApi, useCurrentMediaType } from '@repo-level/core-front';

import { useAuthCookies } from 'hooks/authCookies';
import { brandAssets, BrandAssets } from 'api/cms/brandAssets';

export interface CommonUtilsContextData {
  isMobile: boolean;
  isMobileS: boolean;
  brandAssetsData?: BrandAssets;
  isLiveSpinsAvailable: boolean;
}

export const CommonUtilsContext = createContext<CommonUtilsContextData>(
  null as any
);

export const CommonUtilsContextProvider: FC = ({ children }) => {
  const currentMediaType = useCurrentMediaType();

  useAuthCookies();

  const isMobile = useMemo(() => {
    switch (currentMediaType) {
      case MediaType.MOBILE:
      case MediaType.MOBILE_S:
        return true;
      default:
        return false;
    }
  }, [currentMediaType]);

  const isMobileS = useMemo(() => currentMediaType === MediaType.MOBILE_S, [
    currentMediaType,
  ]);

  const isLiveSpinsAvailable = false;

  const [requestBrandAssets, { data: brandAssetsData }] = useApi(brandAssets);

  useEffect(() => {
    requestBrandAssets();
  }, [requestBrandAssets]);

  return (
    <CommonUtilsContext.Provider
      value={{
        isMobile,
        isMobileS,
        brandAssetsData,
        isLiveSpinsAvailable,
      }}
    >
      {children}
    </CommonUtilsContext.Provider>
  );
};
